"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var svgs_1 = require("../assets/svgs");
var utils_1 = require("../utils");
var Item = function (_a) {
    var file_name = _a.file_name, url = _a.url, timeExpired = _a.timeExpired;
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: {
                alignItems: 'center',
                paddingY: '1.2rem',
                borderColor: 'primary.300',
                borderTopStyle: 'solid',
                borderBottomStyle: 'solid',
                borderWidth: '0.1rem',
                marginBottom: '-0.1rem',
            }, spacing: "1.2rem" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { children: (0, jsx_runtime_1.jsx)(svgs_1.DocumentPdf, {}) }), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ download: true, href: url, target: url.match('apps-beta') ? '_blank' : '', sx: {
                        color: 'primary.600',
                        fontSize: '1.4rem',
                        '&:hover': {
                            color: 'primary.main',
                            textDecoration: 'underline',
                        },
                    } }, { children: file_name })), timeExpired && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", sx: { color: 'primary.400' } }, { children: (0, utils_1.timeLocalizer)(timeExpired) })))] })) })));
};
var DocumentList = function (_a) {
    var data = _a.data, time_expired = _a.time_expired;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, columnSpacing: "2.4rem", mb: "2.8rem" }, { children: data.map(function (item, index) {
                return item.url ? ((0, jsx_runtime_1.jsx)(Item, { file_name: item.name, url: item.url, timeExpired: time_expired }, index)) : null;
            }) })) }));
};
exports.DocumentList = DocumentList;
